<template>
<main-banner></main-banner>
<description></description>
<project></project>
<presentation></presentation>
<popular></popular>
<news></news>
</template>

<script>
import MainBanner from './components/MainBanner.vue';
import Description from './components/Description.vue';
import Project from './components/Project.vue';
import Presentation from './components/Presentation.vue';
import Popular from './components/Popular.vue';
import News from './components/News.vue';
import { mapActions } from 'vuex';
export default {
    name: 'App',
    components: { MainBanner, Description, Project, Presentation, Popular, News },
    mixins: [],
    props: {
        data: {
            type: Object,
            default: () => ({})
        },
        popular: {
            type: Object,
            default: () => ({})
        }
    },
    watch: {
        data: {
            handler(newValue) {
                this.updateDataFromProps(newValue);
            },
            deep: true,
            immediate: true
        },
        popular: {
            handler(newValue) {
                this.updatePopularFromProps(newValue);
            },
            deep: true,
            immediate: true
        },
    },
    data() {
        return {};
    },
    mounted() { },
    computed: {
    },
    methods: {
        ...mapActions(['updateDataFromProps', 'updatePopularFromProps'])
    }
}
</script>
